import { render } from "./UnifiedLogin.vue?vue&type=template&id=12d2222d&scoped=true"
import script from "./UnifiedLogin.vue?vue&type=script&lang=js"
export * from "./UnifiedLogin.vue?vue&type=script&lang=js"

import "./UnifiedLogin.vue?vue&type=style&index=0&id=12d2222d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d2222d"]])

export default __exports__